"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessLoggerService = void 0;
const static_service_1 = require("@wix/static-service");
const definitions_1 = require("../definitions");
const businessLogger_1 = require("../businessLogger");
exports.BusinessLoggerService = (0, static_service_1.implementStaticService)(definitions_1.BusinessLoggerDefinition, () => {
    return (0, businessLogger_1.createBusinessLoggerNoop)();
});
//# sourceMappingURL=businessLoggerService.js.map